module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraBold.9e55aa7.woff2";